import { useContext } from 'react';
import { AnchorItemContext } from '../context/anchorItem';
export function useParentAnchorItem() {
  return useContext(AnchorItemContext);
}